/* Verasah — product page behaviours (deferred) */

/* ── Victoria Public Holiday Engine ── */
function getVicHolidays(year) {
  var h = [];
  function sub(d) {
    var wd = d.getDay();
    if (wd === 6) return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 2);
    if (wd === 0) return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
    return d;
  }
  function nthDay(y, m, wd, n) {
    var dt = new Date(y, m - 1, 1);
    dt.setDate(1 + (wd - dt.getDay() + 7) % 7 + (n - 1) * 7);
    return dt;
  }
  function easter(y) {
    var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,
        f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),
        hh=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,
        l=(32+2*e+2*i-hh-k)%7,m=Math.floor((a+11*hh+22*l)/451),
        mo=Math.floor((hh+l-7*m+114)/31),dy=((hh+l-7*m+114)%31)+1;
    return new Date(y, mo-1, dy);
  }
  // New Year's Day
  h.push(sub(new Date(year,0,1)));
  // Australia Day
  h.push(sub(new Date(year,0,26)));
  // Labour Day — 2nd Monday March
  h.push(nthDay(year,3,1,2));
  // Easter
  var e = easter(year);
  h.push(new Date(e.getFullYear(),e.getMonth(),e.getDate()-2)); // Good Friday
  h.push(new Date(e.getFullYear(),e.getMonth(),e.getDate()-1)); // Easter Saturday
  h.push(new Date(e.getFullYear(),e.getMonth(),e.getDate()));   // Easter Sunday
  h.push(new Date(e.getFullYear(),e.getMonth(),e.getDate()+1)); // Easter Monday
  // Anzac Day
  h.push(sub(new Date(year,3,25)));
  // King's Birthday (VIC) — 2nd Monday June
  h.push(nthDay(year,6,1,2));
  // AFL Grand Final Friday — last Friday of September
  var afl = new Date(year,8,30);
  while (afl.getDay() !== 5) afl.setDate(afl.getDate()-1);
  h.push(afl);
  // Melbourne Cup — 1st Tuesday November
  h.push(nthDay(year,11,2,1));
  // Christmas Day
  h.push(sub(new Date(year,11,25)));
  // Boxing Day
  var xmasDay = new Date(year,11,25).getDay();
  var bd = xmasDay === 5 ? new Date(year,11,28) : sub(new Date(year,11,26));
  h.push(bd);
  return h;
}

function isVicHoliday(date, holidays) {
  return holidays.some(function(h) {
    return h.getFullYear()===date.getFullYear() && h.getMonth()===date.getMonth() && h.getDate()===date.getDate();
  });
}

function addBusinessDays(start, days) {
  var d = new Date(start);
  var hy = getVicHolidays(d.getFullYear()).concat(getVicHolidays(d.getFullYear()+1));
  var added = 0;
  while (added < days) {
    d.setDate(d.getDate()+1);
    var wd = d.getDay();
    if (wd !== 0 && wd !== 6 && !isVicHoliday(d, hy)) added++;
  }
  return d;
}

function fmtDeliveryDate(d) {
  var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  return days[d.getDay()]+', '+d.getDate()+' '+months[d.getMonth()]+' '+d.getFullYear();
}

document.addEventListener('DOMContentLoaded', function () {

  /* ── Read data passed from Liquid ── */
  var dataEl = document.getElementById('product-page-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var productData        = data.product;
  var initSelectedId     = data.selectedVariantId;
  var isHighJewellery    = data.isHighJewellery || false;
  var metalOptionIndex   = (typeof data.metalOptionIndex === 'number') ? data.metalOptionIndex : null;
  var currentVariantPrice = 0;   // tracked in cents, updated on variant change
  var currentUpgradePrice = 0;   // upgrade add-on in cents, updated on delivery option change

  /* ── RTS delivery date calculation — detect by DOM, not JSON ── */
  var deliveryDateStr = '';
  var rtsDateEl = document.querySelector('[data-rts-delivery-date]');
  var isRts = !!rtsDateEl;   // true only if RTS date element exists in the DOM
  if (isRts) {
    var today = new Date();
    today.setHours(0,0,0,0);
    var deliveryDate = addBusinessDays(today, 5);
    deliveryDateStr = fmtDeliveryDate(deliveryDate);
    rtsDateEl.textContent = deliveryDateStr;
  }

  /* ── Per-SKU stock (2026-10-28): a variant with stock ("stock" in the JSON,
     only when tracked in Shopify and above 0) is Ready to ship -- "Only N
     left" and the ready-to-ship Arrives-by date; any other variant shows the
     made-to-order date. ── */
  /* Live stock (2026-10-28) from /products/<handle>?view=stock-data -- the
     page's own stock can be minutes old (cache, or a sale since it loaded).
     Resolves to { variantId: stock } or null on any error/2 s timeout;
     callers treat null as "can't confirm" = made to order. */
  function fetchLiveStock(handle) {
    if (!handle) return Promise.resolve(null);
    /* No Accept: application/json header -- with it Shopify ignores
       ?view= and returns its standard product JSON (no stock). */
    var request = fetch('/products/' + encodeURIComponent(handle) + '?view=stock-data&_=' + Date.now())
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t) return null;
        var parsed = JSON.parse(t);
        if (!Array.isArray(parsed.variants) || parsed.product) return null; /* not the stock view: unknown */
        /* { stock: {id: n}, sizes: {id: ["N", ...]} } -- sizes = ticked
           "Stock ring sizes" (rings: one piece per ticked size). */
        var map = { stock: {}, sizes: {} };
        parsed.variants.forEach(function (v) {
          map.stock[v.id] = Number(v.stock) || 0;
          map.sizes[v.id] = Array.isArray(v.sizes) ? v.sizes : [];
        });
        return map;
      })
      .catch(function () { return null; });
    var timeout = new Promise(function (resolve) { setTimeout(function () { resolve(null); }, 2000); });
    return Promise.race([request, timeout]);
  }

  /* Green dot on each Metal type coin whose variant (with the current carat
     and quality) has stock. */
  function updateCoinDots() {
    try {
      if (metalOptionIndex === null) return;
      document.querySelectorAll('.metal-coin').forEach(function (coin) {
        var v = productData.variants.find(function (x) {
          return x.options.every(function (o, i) {
            return i === metalOptionIndex ? o === coin.dataset.optionValue : (selectedOptions[i] === null || o === selectedOptions[i]);
          });
        });
        /* Rings: only when sizes are ticked (stock without sizes is made to order). */
        coin.classList.toggle('has-stock', !!(v && v.stock > 0 && (!productData.isRing || stockSizes(v).length > 0)));
      });
    } catch (e) { /* display only */ }
  }

  /* Ring size stock (2026-10-28): on rings, a variant's stock only counts
     for the sizes ticked in "Stock ring sizes" -- one piece per ticked
     size. Ring stock with no sizes ticked = made to order (never a false
     promise). Other jewellery: the variant's stock as is. */
  function selectedRingSize() {
    var select = document.querySelector('.ring-size-select');
    return select ? select.value : '';
  }
  function stockSizes(variant) {
    if (!variant || !(variant.stock > 0) || !Array.isArray(variant.sizes)) return [];
    /* More sizes ticked than pieces in stock = a sold size hasn't been
       unticked yet; can't tell which is left, so none is ready to ship. */
    return variant.sizes.length <= variant.stock ? variant.sizes : [];
  }
  function effectiveStock(variant) {
    if (!variant || !(variant.stock > 0)) return 0;
    if (!productData.isRing) return variant.stock;
    var size = selectedRingSize();
    return size && stockSizes(variant).indexOf(size) !== -1 ? 1 : 0;
  }

  function updateStock(variant) {
    var dateEl = document.querySelector('[data-completion-date-text]');
    var lineEl = document.querySelector('[data-stock-line]');
    var leftEl = document.querySelector('[data-stock-left]');
    var stock = effectiveStock(variant);
    /* Ring with stock in other sizes than the one picked (or none picked
       yet): say which sizes are ready, keep the made-to-order date. */
    var readySizes = productData.isRing && stock === 0 ? stockSizes(variant) : [];
    if (lineEl) lineEl.hidden = stock === 0 && readySizes.length === 0;
    if (leftEl) leftEl.textContent = stock > 0 ? 'Only ' + stock + ' left' : (readySizes.length ? 'in size ' + readySizes.join(', ') : '');
    if (dateEl && window.vArrival) {
      var bd = stock > 0 ? dateEl.getAttribute('data-rts-bd') : dateEl.getAttribute('data-mto-bd');
      if (bd) {
        dateEl.setAttribute('data-arrival-bd', bd);
        dateEl.textContent = window.vArrival(bd);
      }
    }
  }

  function updateAtcPrice() {
    var total = currentVariantPrice + currentUpgradePrice;
    var formatted = window.vMoney(total);
    var atcPriceEl = document.querySelector('[data-atc-price]');
    if (atcPriceEl) atcPriceEl.textContent = ' — ' + formatted;
  }

  /* ── Gallery ── */
  var currentIndex = 0;

  function getSlides() { return Array.from(document.querySelectorAll('[data-gallery-slide]')); }
  function getThumbs() { return Array.from(document.querySelectorAll('[data-gallery-thumb]')); }

  function goTo(index) {
    var allSlides = getSlides();
    var allThumbs = getThumbs();
    var total = allSlides.length;
    if (!total) return;
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;
    currentIndex = index;

    document.querySelectorAll('[data-gallery-video]').forEach(function (v) { v.pause(); });
    allSlides.forEach(function (s) { s.classList.toggle('is-active', Number(s.dataset.gallerySlide) === index); });
    allThumbs.forEach(function (t) { t.classList.toggle('is-active', Number(t.dataset.galleryThumb) === index); });

    var activeSlide = document.querySelector('[data-gallery-slide="' + index + '"]');
    if (activeSlide) {
      var vid = activeSlide.querySelector('[data-gallery-video]');
      if (vid) { vid.play().catch(function () {}); }
    }
    var activeThumb = document.querySelector('[data-gallery-thumb="' + index + '"]');
    if (activeThumb) { activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); }
  }

  /* Thumb click — event delegation so it works after DOM reorder */
  var thumbsContainer = document.querySelector('.product-gallery__thumbs');
  if (thumbsContainer) {
    thumbsContainer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gallery-thumb]');
      if (t) goTo(Number(t.dataset.galleryThumb));
    });
  }

  /* Prev/Next arrow buttons */
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

  /* Touch swipe on main gallery image */
  var galleryMain = document.getElementById('product-gallery-main');
  if (galleryMain) {
    var touchStartX = 0;
    galleryMain.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) { goTo(dx < 0 ? currentIndex + 1 : currentIndex - 1); }
    }, { passive: true });
  }

  /* ── Metal gallery switching — builds gallery from metafield data ── */
  var _MUTED_ICON = '<svg data-icon-muted width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M11 5 6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  var _SOUND_ICON = '<svg data-icon-sound width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="display:none"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>';

  function _buildSlide(src, idx, isVideo) {
    var div = document.createElement('div');
    div.className = 'product-gallery__slide' + (idx === 0 ? ' is-active' : '');
    div.dataset.gallerySlide = idx;
    div.dataset.mediaType = isVideo ? 'video' : 'image';
    if (isVideo) {
      var wrap = document.createElement('div');
      wrap.className = 'product-gallery__video-wrap';
      var vid = document.createElement('video');
      vid.className = 'product-gallery__image product-gallery__video-media';
      if (idx === 0) vid.setAttribute('autoplay', '');
      vid.muted = true; vid.loop = true;
      vid.setAttribute('playsinline', ''); vid.setAttribute('data-gallery-video', '');
      var src_el = document.createElement('source');
      src_el.src = src; src_el.type = 'video/mp4';
      vid.appendChild(src_el);
      var mb = document.createElement('button');
      mb.className = 'product-gallery__video-mute';
      mb.setAttribute('aria-label', 'Toggle sound');
      mb.innerHTML = _MUTED_ICON + _SOUND_ICON;
      mb.addEventListener('click', function () {
        vid.muted = !vid.muted;
        mb.querySelector('[data-icon-muted]').style.display = vid.muted ? '' : 'none';
        mb.querySelector('[data-icon-sound]').style.display = vid.muted ? 'none' : '';
      });
      wrap.appendChild(vid); wrap.appendChild(mb);
      div.appendChild(wrap);
    } else {
      var img = document.createElement('img');
      img.src = src;
      img.alt = (productData && productData.title) || '';
      img.className = 'product-gallery__image product-gallery__image--zoomable';
      img.loading = idx === 0 ? 'eager' : 'lazy';
      img.setAttribute('data-lightbox-trigger', '');
      img.setAttribute('data-lightbox-index', idx);
      img.setAttribute('data-lightbox-src', src);
      div.appendChild(img);
    }
    return div;
  }

  function _buildThumb(src, idx, isVideo) {
    var btn = document.createElement('button');
    btn.className = 'product-gallery__thumb' + (idx === 0 ? ' is-active' : '');
    btn.dataset.galleryThumb = idx;
    btn.setAttribute('aria-label', (isVideo ? 'Play video ' : 'View image ') + (idx + 1));
    if (isVideo) {
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polygon points="10 8 16 12 10 16 10 8" fill="currentColor"/></svg><span class="product-gallery__thumb-play" aria-hidden="true"><svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg></span>';
    } else {
      var img = document.createElement('img');
      img.src = src; img.alt = ''; img.loading = 'lazy';
      btn.appendChild(img);
    }
    return btn;
  }

  function switchGallery(metalKey) {
    var gMain = document.getElementById('product-gallery-main');
    if (!gMain || !metalKey) return;

    var metalMedia = data.metalMedia || {};
    var allImages  = data.allImages  || [];
    var primary    = metalMedia[metalKey] || {};
    var primImages = primary.images || [];
    var primVideo  = primary.video  || null;

    /* Other images = all product images not in the primary set */
    var primSet = {};
    primImages.forEach(function (u) { primSet[u] = true; });
    var otherImages = allImages.filter(function (u) { return !primSet[u]; });

    /* Remove existing slides and thumbs */
    Array.from(gMain.querySelectorAll('[data-gallery-slide]')).forEach(function (s) { gMain.removeChild(s); });
    var thumbsEl = document.querySelector('.product-gallery__thumbs');
    if (thumbsEl) {
      Array.from(thumbsEl.querySelectorAll('[data-gallery-thumb]')).forEach(function (t) { thumbsEl.removeChild(t); });
    }

    var idx = 0;
    function addItem(src, isVideo) {
      gMain.appendChild(_buildSlide(src, idx, isVideo));
      if (thumbsEl) thumbsEl.appendChild(_buildThumb(src, idx, isVideo));
      idx++;
    }

    if (primVideo)  addItem(primVideo, true);
    primImages.forEach(function (u)  { addItem(u, false); });
    otherImages.forEach(function (u) { addItem(u, false); });

    currentIndex = 0;

    /* Autoplay first video if present */
    if (primVideo) {
      var fv = gMain.querySelector('[data-gallery-slide="0"] [data-gallery-video]');
      if (fv) { fv.muted = true; fv.play().catch(function () {}); }
    }
  }

  /* Inline mute via event delegation — works on dynamically created buttons */
  document.getElementById('product-gallery-main').addEventListener('click', function (e) {
    var btn = e.target.closest('.product-gallery__video-mute');
    if (!btn) return;
    var wrap = btn.closest('.product-gallery__video-wrap');
    if (!wrap) return;
    var vid = wrap.querySelector('[data-gallery-video]');
    if (!vid) return;
    vid.muted = !vid.muted;
    var mi = btn.querySelector('[data-icon-muted]');
    var si = btn.querySelector('[data-icon-sound]');
    if (mi) mi.style.display = vid.muted ? '' : 'none';
    if (si) si.style.display = vid.muted ? 'none' : '';
  });

  /* ── Variant selection ── */
  var form = document.querySelector('#product-form');
  if (!form) return;
  var optionBtns    = form.querySelectorAll('[data-option-value]');
  var variantInput  = form.querySelector('[data-variant-id]');
  var selectedOptions = productData.options.map(function () { return null; });

  var initVariant = productData.variants.find(function (v) { return v.id === initSelectedId; });

  /* On load: refresh stock from Shopify (the page HTML can be cached) and
     redraw the Ready-to-ship line and coin dots. A failure keeps the page's
     own values. */
  fetchLiveStock(productData.handle).then(function (live) {
    if (!live) return;
    productData.variants.forEach(function (v) { v.stock = live.stock[v.id] || 0; v.sizes = live.sizes[v.id] || []; });
    var current = productData.variants.find(function (v) { return variantInput && v.id === Number(variantInput.value); });
    updateStock(current);
    updateCoinDots();
  });
  setTimeout(updateCoinDots, 0);

  if (initVariant) {
    initVariant.options.forEach(function (o, i) { selectedOptions[i] = o; });
    currentVariantPrice = initVariant.price;
    var priceEl = document.querySelector('[data-price]');
    if (priceEl) priceEl.textContent = window.vMoney(initVariant.price);
    updateAtcPrice();
  }

  /* ── Gold Colour swatches (property-only, not a real variant option) ── */
  var goldColourSwatches   = document.querySelectorAll('.gold-colour-swatch');
  var goldColourProp       = document.getElementById('gold-colour-prop');
  /* Was '.product-info__gold-colour' -- that wrapper div no longer exists
     since Gold Colour merged inline into the Metal section (2026-09-03);
     '.gold-colour-swatches' is the closest surviving container to grey out. */
  var goldColourContainer  = document.querySelector('.gold-colour-swatches');
  /* On page load: switch gallery to match initial metal/colour */
  (function () {
    var initIsSilver = metalOptionIndex !== null && selectedOptions[metalOptionIndex] === 'Silver 925';
    if (initIsSilver) {
      switchGallery('white-gold');
    } else {
      /* Find which gold colour swatch (or metal coin) is pre-selected, default yellow */
      var activeSwatch = document.querySelector('.gold-colour-swatch.is-selected, .metal-coin.is-selected');
      var initKey = (activeSwatch && activeSwatch.dataset.goldKey) || 'yellow-gold';
      switchGallery(initKey);
    }
  }());

  if (goldColourSwatches.length) {
    goldColourSwatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        goldColourSwatches.forEach(function (b) {
          var isThis = b === btn;
          b.classList.toggle('is-selected', isThis);
          b.setAttribute('aria-checked', isThis ? 'true' : 'false');
        });
        if (goldColourProp) goldColourProp.value = btn.dataset.goldColour;
        switchGallery(btn.dataset.goldKey);
      });
    });
  }

  /* ── Chain Length pills (property-only, not a real variant option --
     price is fixed at the 18-inch chain weight for every unit as of
     2026-09-03, see pricing-engine) ── */
  var chainLengthPills = document.querySelectorAll('.chain-length-pills [data-chain-length]');
  var chainLengthProp  = document.getElementById('chain-length-prop');
  var chainLengthCombinedEl = document.querySelector('[data-chain-length-combined]');
  if (chainLengthPills.length) {
    chainLengthPills.forEach(function (btn) {
      btn.addEventListener('click', function () {
        chainLengthPills.forEach(function (b) {
          var isThis = b === btn;
          b.classList.toggle('is-selected', isThis);
          b.setAttribute('aria-checked', isThis ? 'true' : 'false');
        });
        if (chainLengthProp) chainLengthProp.value = btn.dataset.chainLength;
        if (chainLengthCombinedEl) {
          var parts = btn.dataset.chainLength.split(' ');
          chainLengthCombinedEl.textContent = parts[0] + ' ' + parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
        }
      });
    });
  }

  /* Silver 925 has no gold colour variants -- disable and clear the swatches
     while it's selected, restoring Yellow Gold as the default once a real
     gold metal is picked again. */
  function updateGoldColourAvailability() {
    if (!goldColourSwatches.length || metalOptionIndex === null) return;
    var isSilver = selectedOptions[metalOptionIndex] === 'Silver 925';

    if (goldColourContainer) goldColourContainer.classList.toggle('is-disabled', isSilver);

    goldColourSwatches.forEach(function (b) {
      b.disabled = isSilver;
      b.setAttribute('aria-disabled', isSilver ? 'true' : 'false');
      if (isSilver) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-checked', 'false');
      }
    });

    if (isSilver) {
      if (goldColourProp) goldColourProp.value = '';
      switchGallery('white-gold');
    } else {
      var anySelected = Array.prototype.some.call(goldColourSwatches, function (b) {
        return b.classList.contains('is-selected');
      });
      if (!anySelected) {
        var yellow = document.querySelector('.gold-colour-swatch[data-gold-key="yellow-gold"]');
        if (yellow) {
          yellow.classList.add('is-selected');
          yellow.setAttribute('aria-checked', 'true');
        }
        if (goldColourProp) goldColourProp.value = 'Yellow Gold';
        switchGallery('yellow-gold');
      }
    }
  }
  updateGoldColourAvailability();

  function findVariant() {
    return productData.variants.find(function (v) {
      return v.options.every(function (o, i) { return selectedOptions[i] === null || o === selectedOptions[i]; });
    });
  }

  optionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = Number(btn.dataset.optionIndex);
      var val = btn.dataset.optionValue;
      selectedOptions[idx] = val;

      form.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (b) {
        b.setAttribute('aria-checked', b.dataset.optionValue === val ? 'true' : 'false');
        b.classList.toggle('is-selected', b.dataset.optionValue === val);
        b.classList.toggle('is-active',   b.dataset.optionValue === val);
      });

      if (idx === metalOptionIndex) {
        updateGoldColourAvailability();
      }
      /* Metal type coin (gold colour is part of the variant, 2026-10-28):
         show that colour's photos, as the Gold Colour swatches do. */
      if (btn.dataset.goldKey) switchGallery(btn.dataset.goldKey);

      var labelEl = document.querySelector('[data-selected-option="' + idx + '"]');
      if (labelEl) labelEl.textContent = val;

      /* Details rows follow the selected carat (2026-10-26, multi-carat
         products only): rows for each carat come from #dims-by-carat. */
      if (productData && productData.options && productData.options[idx] === 'Carat') {
        var dimsEl = document.getElementById('dims-by-carat');
        var dimList = document.querySelector('[data-dim-list]');
        if (dimsEl && dimList) {
          var byCarat = {};
          try { byCarat = JSON.parse(dimsEl.textContent) || {}; } catch (e) { byCarat = {}; }
          var rows = byCarat[val];
          if (Array.isArray(rows) && rows.length) {
            dimList.innerHTML = '';
            rows.forEach(function (r) {
              var row = document.createElement('div');
              row.className = 'dim-list__row';
              var l = document.createElement('span');
              l.className = 'dim-list__label';
              l.textContent = r.label;
              var v = document.createElement('span');
              v.className = 'dim-list__value';
              v.textContent = r.value;
              row.appendChild(l);
              row.appendChild(v);
              dimList.appendChild(row);
            });
          }
        }
      }

      /* Crafting Speed -- update the "Arrives by" text for the clicked pill:
         business days from today via window.vArrival (theme.liquid), falling
         back to the pill's server-rendered date if the helper is missing. */
      if (btn.dataset.speedBd || btn.dataset.completionDate) {
        var completionDateEl = document.querySelector('[data-completion-date-text]');
        if (completionDateEl) {
          if (btn.dataset.speedBd && window.vArrival) {
            completionDateEl.setAttribute('data-arrival-bd', btn.dataset.speedBd);
            completionDateEl.textContent = window.vArrival(btn.dataset.speedBd);
          } else {
            completionDateEl.textContent = btn.dataset.completionDate;
          }
        }
      }


      var variant = findVariant();
      if (variant) {
        variantInput.value = variant.id;
        currentVariantPrice = variant.price;
        var priceFormatted = window.vMoney(variant.price);
        var priceEl = document.querySelector('[data-price]');
        if (priceEl) priceEl.textContent = priceFormatted;
        var atcBtnEl = document.querySelector('[data-atc-btn]');
        if (atcBtnEl) {
          atcBtnEl.disabled = !variant.available;
          if (!variant.available) {
            atcBtnEl.innerHTML = 'Sold out';
          } else {
            var existingPriceSpan = atcBtnEl.querySelector('[data-atc-price]');
            if (!existingPriceSpan) {
              atcBtnEl.innerHTML = 'Add to cart <span class="product-info__atc-price" data-atc-price></span>';
            }
          }
        }
        // Always recalculate with current upgrade after variant change
        updateAtcPrice();
        updateStock(variant);
        updateCoinDots();
      }
    });
  });

  /* ── Chain length is now a Shopify variant (Option A) — no separate chain
     product lookup or add-to-cart needed. Shopify's standard variant JS
     handles price updates and cart automatically. ���─ */

  /* ── Delivery selector ── */
  var deliverySelector   = document.querySelector('[data-delivery-selector]');
  var selectedUpgradeId  = null;   // variant ID of chosen upgrade, null = standard

  if (deliverySelector) {
    var toggleBtn   = deliverySelector.querySelector('[data-delivery-toggle]');
    var delivPanel  = deliverySelector.querySelector('[data-delivery-panel]');
    var displayEl   = deliverySelector.querySelector('[data-delivery-display]');
    var delOptions  = deliverySelector.querySelectorAll('[data-delivery-option]');

    // Open / close the options panel
    if (toggleBtn && delivPanel) {
      toggleBtn.addEventListener('click', function () {
        var isOpen = !delivPanel.hidden;
        delivPanel.hidden = isOpen;
        toggleBtn.setAttribute('aria-expanded', String(!isOpen));
      });
    }

    // Option selection — read price and variant from the option's own data attributes
    delOptions.forEach(function (opt) {
      opt.addEventListener('click', function () {
        // Update visual selection
        delOptions.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');

        // Update displayed date
        var dateEl = opt.querySelector('.delivery-option__date');
        if (dateEl && displayEl) displayEl.textContent = dateEl.textContent;

        // Read price + variant directly from this option element
        currentUpgradePrice = parseInt(opt.dataset.upgradePrice || 0, 10);
        selectedUpgradeId   = opt.dataset.upgradeVariant || null;

        // Update ATC button price
        updateAtcPrice();

        // Close panel
        if (delivPanel) { delivPanel.hidden = true; }
        if (toggleBtn)  { toggleBtn.setAttribute('aria-expanded', 'false'); }
      });
    });

    // Close if clicking outside
    document.addEventListener('click', function (e) {
      if (!deliverySelector.contains(e.target) && delivPanel && !delivPanel.hidden) {
        delivPanel.hidden = true;
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Ring size picked: clear the "Please select your ring size" message. */
  var ringSizeRequired = form.querySelector('.ring-size-select');
  if (ringSizeRequired) {
    ringSizeRequired.addEventListener('change', function () {
      /* Ready to ship depends on the size on rings. */
      updateStock(productData.variants.find(function (v) { return variantInput && v.id === Number(variantInput.value); }));
      if (!ringSizeRequired.value) return;
      ringSizeRequired.classList.remove('is-invalid');
      var sizeError = document.querySelector('[data-ring-size-error]');
      if (sizeError) sizeError.hidden = true;
    });
  }

  /* ── Add to cart ── */
  var atcBtn = document.querySelector('[data-atc-btn]');
  if (atcBtn) {
    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      /* Rings only (2026-10-28): the size dropdown only exists on ring
         products; without a size, nothing is added. */
      var sizeSelect = form.querySelector('.ring-size-select');
      if (sizeSelect && !sizeSelect.value) {
        var sizeError = document.querySelector('[data-ring-size-error]');
        if (sizeError) sizeError.hidden = false;
        sizeSelect.classList.add('is-invalid');
        sizeSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizeSelect.focus({ preventScroll: true });
        return;
      }

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      /* ── Optimistic UI: open drawer immediately with loading state ── */
      var drawer = document.getElementById('cart-drawer');
      var cartItemsEl = document.querySelector('[data-cart-items]');
      if (cartItemsEl) {
        cartItemsEl.innerHTML =
          '<div style="padding:1.5rem 1rem;display:flex;flex-direction:column;gap:1rem;">' +
          '<div style="height:80px;background:var(--bg-alt);border-radius:4px;animation:srb-pulse 1.2s ease-in-out infinite;"></div>' +
          '<div style="height:80px;background:var(--bg-alt);border-radius:4px;animation:srb-pulse 1.2s ease-in-out infinite;opacity:.6;"></div>' +
          '</div>' +
          '<style>@keyframes srb-pulse{0%,100%{opacity:.4}50%{opacity:1}}</style>';
      }
      if (drawer) drawer.classList.add('is-open');

      /* ── Build delivery date property ── */
      var deliveryPropValue = '';
      if (isRts) {
        deliveryPropValue = deliveryDateStr;
      } else {
        var displayEl = document.querySelector('[data-delivery-display]');
        if (displayEl) deliveryPropValue = displayEl.textContent.trim();
      }

      /* ── Build cart payload as JSON so properties are reliably sent ── */
      var formData = new FormData(form);
      var variantId = parseInt(formData.get('id'), 10);
      var quantity  = parseInt(formData.get('quantity') || 1, 10);
      var properties = {};
      // Carry over any existing form properties (e.g. engraving)
      for (var pair of formData.entries()) {
        var propMatch = pair[0].match(/^properties\[(.+)\]$/);
        if (propMatch) properties[propMatch[1]] = pair[1];
      }
      if (deliveryPropValue) {
        properties[isRts ? 'Estimated Delivery' : 'Completion Date'] = deliveryPropValue;
      }

      /* Get product title for upgrade linking */
      var productTitleEl = document.querySelector('[data-product-title]');
      var productTitle = productTitleEl ? productTitleEl.dataset.productTitle : (document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : '');

      /* Build items for VerasahCart.add() — fires verasah:cart event which
         re-renders both the drawer AND the cart page automatically */
      var uid = Date.now() + '-' + Math.random().toString(36).slice(2,7);
      /* Stamp _uid on the main product so upgrades can match precisely by UID
         (avoids ambiguity when the same product is added twice with different variants) */
      properties['_uid'] = uid;
      var cartItems = [{ id: variantId, quantity: quantity, properties: properties }];
      if (selectedUpgradeId) {
        cartItems.push({
          id: Number(selectedUpgradeId),
          quantity: 1,
          properties: { '_uid': uid + '-upg', '_for': productTitle, '_for_uid': uid }
        });
      }


      /* Per-SKU stock (2026-10-28): a Ready-to-ship SKU gets its delivery
         date on the cart line, but only while the stock covers it -- units of
         this SKU already in the cart count first. Otherwise the line is made
         to order (no date, as for every other SKU). The date then shows in
         the cart, the drawer, the order and the tax invoice. */
      /* Checked against LIVE stock at the moment of adding (not the stock the
         page loaded with); any failure or 2 s timeout = made to order. */
      var addedVariant = productData.variants.find(function (v) { return v.id === variantId; });
      var stockCheck = (addedVariant && addedVariant.stock > 0)
        ? Promise.all([
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; }),
            fetchLiveStock(productData.handle)
          ])
            .then(function (res) {
              var cart = res[0], live = res[1];
              if (!cart || !live) return;
              var liveStock = live.stock[variantId] || 0;
              var sameVariant = (cart.items || []).filter(function (i) { return i.variant_id === variantId; });
              var inCart = sameVariant.reduce(function (n, i) { return n + i.quantity; }, 0);
              var covered = inCart + quantity <= liveStock;
              if (productData.isRing) {
                /* One piece per ticked size, not already in the cart. */
                var size = properties['Ring Size'] || '';
                var held = live.sizes[variantId] || [];
                var sizes = held.length <= liveStock ? held : []; /* stale ticks: none reliable */
                var sizeInCart = sameVariant.some(function (i) { return (i.properties || {})['Ring Size'] === size; });
                covered = covered && quantity === 1 && !!size && sizes.indexOf(size) !== -1 && !sizeInCart;
              }
              if (covered && window.vArrival) {
                var dateEl = document.querySelector('[data-completion-date-text]');
                properties['Estimated Delivery'] = window.vArrival(dateEl ? dateEl.getAttribute('data-rts-bd') : 5);
              }
            })
            .catch(function () { /* can't confirm: add as made to order */ })
        : Promise.resolve();

      stockCheck
      .then(function () { return VerasahCart.add(cartItems); })
      .then(function () {
        var drawer = document.getElementById('cart-drawer');
        if (drawer) drawer.classList.add('is-open');
        atcBtn.disabled = false;
        var existingPriceEl = atcBtn.querySelector('[data-atc-price]');
        if (!existingPriceEl) { atcBtn.textContent = 'Add to cart'; }
        else { atcBtn.firstChild.textContent = 'Add to cart'; }
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to cart';
        window.location.href = '/cart';
      });
    });
  }

  /* ── Product tabs ── */
  document.querySelectorAll('.product-tabs__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.tab;
      document.querySelectorAll('.product-tabs__tab').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.product-tabs__panel').forEach(function (p) { p.classList.remove('is-active'); });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      var panel = document.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });

  /* ── Selected options, for Send a Hint and Send an Enquiry (2026-10-25) ──
     The variant currently chosen in the buy box (not the first variant),
     its options by name, the display-only Gold Colour / Ring Size choices,
     and a link straight to that variant. */
  function selectedVariantInfo() {
    var variants = (productData && productData.variants) || [];
    var id = variantInput ? Number(variantInput.value) : NaN;
    var v = variants.find(function (x) { return x.id === id; }) || variants[0] || null;
    var names = (productData && productData.options) || [];
    var opts = {};
    if (v) v.options.forEach(function (val, i) { opts[names[i]] = val; });
    var goldEl = document.getElementById('gold-colour-prop');
    var ringEl = document.querySelector('.ring-size-select');
    var gold = goldEl && opts['Metal'] && opts['Metal'] !== 'Silver 925' ? goldEl.value : '';
    var url = new URL(window.location.href);
    if (v) url.searchParams.set('variant', v.id);
    return {
      variantId: v ? String(v.id) : '',
      price: v ? window.vMoney(v.price) : '',
      carat: opts['Carat'] || '',
      diamondQuality: opts['Diamond Quality'] || '',
      metal: opts['Metal'] || '',
      goldColour: gold,
      ringSize: ringEl ? ringEl.value : '',
      url: url.toString(),
      summary: [opts['Carat'], opts['Diamond Quality'], opts['Metal'], gold].filter(Boolean).join(' · ')
    };
  }

  /* ── Send a hint modal ── */
  var hintBtn   = document.querySelector('[data-send-hint]');
  var hintModal = document.getElementById('hint-modal');
  var hintForm  = document.getElementById('hint-form');

  function openHintModal() {
    if (!hintModal) return;
    hintModal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeHintModal() {
    if (!hintModal) return;
    hintModal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    var successEl = document.getElementById('hint-success');
    var errorEl   = document.getElementById('hint-error');
    if (successEl) successEl.hidden = true;
    if (errorEl)   errorEl.hidden   = true;
    if (hintForm)  hintForm.reset();
  }

  if (hintBtn) hintBtn.addEventListener('click', openHintModal);

  document.querySelectorAll('[data-hint-close]').forEach(function (el) {
    el.addEventListener('click', closeHintModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && hintModal && !hintModal.hidden) closeHintModal();
  });

  var hintSubmitBtn = document.getElementById('hint-submit');
  if (hintSubmitBtn) {
    hintSubmitBtn.addEventListener('click', function (e) {

      var firstName     = document.getElementById('hint-first-name').value.trim();
      var lastName      = document.getElementById('hint-last-name').value.trim();
      var yourEmail     = document.getElementById('hint-your-email').value.trim();
      var recipientEmail = document.getElementById('hint-recipient-email').value.trim();
      var phone         = document.getElementById('hint-phone').value.trim();
      var message       = document.getElementById('hint-message').value.trim();
      var marketing     = document.getElementById('hint-marketing').checked;
      var sms           = document.getElementById('hint-sms').checked;
      var errorEl       = document.getElementById('hint-error');
      var successEl     = document.getElementById('hint-success');
      var submitBtn     = document.getElementById('hint-submit');

      if (!firstName || !lastName || !yourEmail || !recipientEmail || !message) {
        errorEl.textContent = 'Please fill in all required fields.';
        errorEl.hidden = false;
        return;
      }

      errorEl.hidden = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';

      // The variant selected in the buy box (it used to always send the
      // first variant's price and the plain page link).
      var hintInfo     = selectedVariantInfo();
      var productTitle = productData ? (productData.title || document.title) : document.title;
      if (hintInfo.summary) productTitle += ' — ' + hintInfo.summary;
      var productUrl   = hintInfo.url;
      var productImage = '';
      var productPrice = hintInfo.price;
      // Get image URL from data attribute already on the page (most reliable source)
      var wishlistBtn = document.querySelector('[data-product-image]');
      if (wishlistBtn) {
        var rawImage = wishlistBtn.getAttribute('data-product-image') || '';
        productImage = rawImage ? (rawImage.indexOf('https') === 0 ? rawImage : 'https:' + rawImage) : '';
      }

      // Initialise EmailJS (v4 syntax)
      emailjs.init({ publicKey: 'kpOB888Lk3mhXohG6' });

      // reCAPTCHA v3 — get token then send via EmailJS
      grecaptcha.ready(function() {
        grecaptcha.execute('6LfIuv4tAAAAAKsdmZVZ_T0eTEKgVEhOwD9io2jJ', { action: 'send_hint' })
        .then(function(token) {
          // Block obvious bots (no token generated)
          if (!token) {
            errorEl.textContent = 'Security check failed. Please try again.';
            errorEl.hidden = false;
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send Hint';
            return;
          }

          // Send via EmailJS
          emailjs.send('service_6huo298', 'template_jdl9y3m', {
            recipient_email: recipientEmail,
            sender_name:     firstName + ' ' + lastName,
            sender_email:    yourEmail,
            sender_phone:    phone,
            message:         message,
            product_name:    productTitle,
            product_url:     productUrl,
            product_image:   productImage,
            product_price:   productPrice
          })
          .then(function() {
            successEl.hidden = false;
            if (hintForm) hintForm.reset();
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send Hint';
            setTimeout(closeHintModal, 2500);
          })
          .catch(function() {
            errorEl.textContent = 'Something went wrong. Please try again.';
            errorEl.hidden = false;
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send Hint';
          });
        })
        .catch(function() {
          errorEl.textContent = 'Security check failed. Please try again.';
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send Hint';
        });
      });
    });
  }

  /* ── Send an Enquiry modal ── */
  var enquiryBtn   = document.querySelector('[data-send-enquiry]');
  var enquiryModal = document.getElementById('enquiry-modal');

  function openEnquiryModal() {
    if (!enquiryModal) return;
    enquiryModal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeEnquiryModal() {
    if (!enquiryModal) return;
    enquiryModal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  if (enquiryBtn) enquiryBtn.addEventListener('click', openEnquiryModal);

  /* ── Enquiry form submission ── */
  var enquiryForm   = document.getElementById('enquiry-form');
  var enquiryError  = document.getElementById('enquiry-error');
  var enquirySuccessEl = document.getElementById('enquiry-success');
  var enquirySubmitBtn = document.getElementById('enquiry-submit');

  if (enquirySubmitBtn) {
    enquirySubmitBtn.addEventListener('click', function(e) {
      // Basic required field validation
      var valid = true;
      enquiryForm.querySelectorAll('[required]').forEach(function(el) {
        if (!el.value.trim()) { el.style.borderColor = 'var(--error, #c0392b)'; valid = false; }
        else el.style.borderColor = '';
      });
      if (!valid) {
        if (enquiryError) { enquiryError.textContent = 'Please fill in all required fields.'; enquiryError.hidden = false; }
        return;
      }

      if (enquiryError) enquiryError.hidden = true;
      enquirySubmitBtn.disabled = true;
      enquirySubmitBtn.textContent = 'Sending…';

      var firstName   = (enquiryForm.querySelector('[name="first_name"]') || {}).value || '';
      var lastName    = (enquiryForm.querySelector('[name="last_name"]') || {}).value || '';
      var email       = (enquiryForm.querySelector('[name="email"]') || {}).value || '';
      var phone       = (enquiryForm.querySelector('[name="phone"]') || {}).value || '';
      var message     = (enquiryForm.querySelector('[name="message"]') || {}).value || '';
      var optinEmail  = enquiryForm.querySelector('[name="optin_email"]') && enquiryForm.querySelector('[name="optin_email"]').checked;
      var productData = {};
      try { var pdEl = document.getElementById('product-page-data'); if (pdEl) productData = JSON.parse(pdEl.textContent); } catch(e) {}
      var productName = (productData.product && productData.product.title) || document.title;
      var productUrl  = window.location.href;

      var enquiryInfo = selectedVariantInfo();

      grecaptcha.ready(function() {
        grecaptcha.execute('6LfIuv4tAAAAAKsdmZVZ_T0eTEKgVEhOwD9io2jJ', { action: 'send_enquiry' })
        .then(function(token) {
          if (!token) {
            if (enquiryError) { enquiryError.textContent = 'Security check failed. Please try again.'; enquiryError.hidden = false; }
            enquirySubmitBtn.disabled = false;
            enquirySubmitBtn.textContent = 'Send Enquiry';
            return;
          }

          // Sent to the pricing app, which verifies the reCAPTCHA token with
          // Google before passing the enquiry to Klaviyo (2026-10-25; it used
          // to go straight to Klaviyo with the token never checked).
          return fetch('https://motivated-truth-production-cc4c.up.railway.app/api/enquiry-submit', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              firstName: firstName,
              lastName: lastName,
              email: email,
              phone: phone,
              message: message,
              optinEmail: !!optinEmail,
              productName: productName,
              productUrl: enquiryInfo.url,
              carat: enquiryInfo.carat,
              diamondQuality: enquiryInfo.diamondQuality,
              metal: enquiryInfo.metal,
              goldColour: enquiryInfo.goldColour,
              ringSize: enquiryInfo.ringSize,
              price: enquiryInfo.price,
              variantId: enquiryInfo.variantId,
              recaptchaToken: token
            })
          })
          .then(function(res) {
            return res.json().catch(function() { return {}; }).then(function(json) {
              if (!res.ok || !json.success) throw new Error(json.error || 'Something went wrong. Please try again.');
            });
          })
          .then(function() {
            var formFields = document.getElementById('enquiry-form-fields');
            if (formFields) formFields.style.display = 'none';
            if (enquirySuccessEl) {
              enquirySuccessEl.hidden = false;
              enquirySuccessEl.style.display = 'flex';
            }
            setTimeout(function() {
              closeEnquiryModal();
              setTimeout(function() {
                if (formFields) formFields.style.display = '';
                if (enquirySuccessEl) { enquirySuccessEl.hidden = true; enquirySuccessEl.style.display = ''; }
                enquiryForm.querySelectorAll('input:not([type="checkbox"]), textarea').forEach(function(el) { el.value = ''; });
                var cb = enquiryForm.querySelector('[name="optin_email"]'); if (cb) cb.checked = false;
                enquirySubmitBtn.disabled = false;
                enquirySubmitBtn.textContent = 'Send Enquiry';
              }, 500);
            }, 2500);
          })
          .catch(function(err) {
            if (enquiryError) { enquiryError.textContent = (err && err.message) || 'Something went wrong. Please try again.'; enquiryError.hidden = false; }
            enquirySubmitBtn.disabled = false;
            enquirySubmitBtn.textContent = 'Send Enquiry';
          });
        });
      });
    });
  }

  document.querySelectorAll('[data-enquiry-close]').forEach(function (el) {
    el.addEventListener('click', closeEnquiryModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && enquiryModal && !enquiryModal.hidden) closeEnquiryModal();
  });

  /* ── Ring size out-of-range notice ── */
  var ringSizeSelect = document.querySelector('.ring-size-select');
  var ringSizeModal   = document.getElementById('ring-size-modal');
  var OUT_OF_RANGE_SIZES = ['U½', 'V', 'V½', 'W', 'W½', 'X', 'X½', 'Y', 'Y½', 'Z'];

  function openRingSizeModal() {
    if (!ringSizeModal) return;
    ringSizeModal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeRingSizeModal() {
    if (!ringSizeModal) return;
    ringSizeModal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  if (ringSizeSelect) {
    ringSizeSelect.addEventListener('change', function () {
      if (OUT_OF_RANGE_SIZES.indexOf(ringSizeSelect.value) !== -1) openRingSizeModal();
    });
  }

  document.querySelectorAll('[data-ring-size-close]').forEach(function (el) {
    el.addEventListener('click', closeRingSizeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ringSizeModal && !ringSizeModal.hidden) closeRingSizeModal();
  });

  /* ── "Metal: …" label -- selected metal plus, for gold, the selected
     colour (e.g. "18K Gold, Rose Gold"; Silver 925 on its own). It used to
     join every selected option (diamond, speed, …) and ignored the gold
     colour swatches, so it went stale / showed the wrong metal. ── */
  function updateMetalCombinedLabel() {
    var combinedEl = document.querySelector('[data-metal-combined]');
    if (!combinedEl || metalOptionIndex === null) return;
    var metal = selectedOptions[metalOptionIndex];
    if (!metal) return;
    if (metal === 'Silver 925') { combinedEl.textContent = metal; return; }
    /* Colour already in the variant ("9K Yellow Gold"), 2026-10-28 */
    if (/(Yellow|White|Rose) Gold$/.test(metal)) { combinedEl.textContent = metal; return; }
    var colour = '';
    var goldSwatch = document.querySelector('.gold-colour-swatch.is-selected');
    var metalSwatch = document.querySelector('.metal-swatch.is-active');
    if (goldSwatch) colour = goldSwatch.dataset.goldColour;
    else if (metalSwatch) colour = metalSwatch.dataset.optionValue;
    combinedEl.textContent = colour ? metal + ', ' + colour : metal;
  }

  /* .variant-price-pill = the metal buttons (snippets/variant-price-pills) */
  document.querySelectorAll('.variant-pill, .variant-price-pill, .metal-swatch, .gold-colour-swatch, .metal-coin').forEach(function(btn) {
    btn.addEventListener('click', function() {
      setTimeout(updateMetalCombinedLabel, 50);
    });
  });
  updateMetalCombinedLabel();

});
